import { 
	MensurationsRepository,
	AuthRepository,
	MenagementsRepository,
	ComunicationsRepository,
} from "../../api";
import {
	handleChangeInputText,
	handleChangeInputRange,
	handleChangeInputSpecialRange,
	handleChangeInputRadio,
	handleChangeInputCheckbox,
	handleChangeInputTextTable,
	handleChangeInputTextDinamic,
	handleChangeInputLocation,
	handleChangeInputRadioDinamic,
} from "../../helpers";
import { functions } from "../../helpers/subcategoriesFunctions/index";
import {
	categoriesFormsModel,
	
	mensurationSteps,
	menagementSteps,
	comunicationsSteps,

	mensurationQuestions,
	menagementQuestions,
	comunicationQuestions,
	Auth,

} from "../../models";
import { MenagementReport } from "../../models/lib/entities/MenagementReport";
import { MensurationReport } from "../../models/lib/entities/MensurationReport";
import { ComunicationReport } from "../../models/lib/entities/ComunicationReport";


export class DashboardController {
	constructor(context) {
		this.context = context;

		this.mensurationsRepo = new MensurationsRepository();
		this.authRepo = new AuthRepository();
		this.menagementsRepo = new MenagementsRepository();
		this.comunicationsRepo = new ComunicationsRepository();

		this.getSubcategoriesFromCategoryId = this.getSubcategoriesFromCategoryId.bind(context);
		this.changeCategory = this.changeCategory.bind(context);
		this.changeSubcategory = this.changeSubcategory.bind(context);
		this.nextSubcategory = this.nextSubcategory.bind(context);
		this.prevSubcategory = this.prevSubcategory.bind(context);
		this.selectFunctions = this.selectFunctions.bind(context);
		this.changeAction = this.changeAction.bind(context);
		this.doneAction = this.doneAction.bind(context);
		this.init = this.init.bind(context);
		this.linkMenu = this.linkMenu.bind(context);
		this.setDinamicValues = this.setDinamicValues.bind(context);

		this.handleChangeInputText = handleChangeInputText;
		this.handleChangeInputRange = handleChangeInputRange;
		this.handleChangeInputRadio = handleChangeInputRadio;
		this.handleChangeInputCheckbox = handleChangeInputCheckbox;
		this.handleChangeInputCheckbox = handleChangeInputCheckbox;
		this.handleChangeInputTextTable = handleChangeInputTextTable;
		this.handleChangeInputTextDinamic = handleChangeInputTextDinamic;
		this.handleChangeInputLocation = handleChangeInputLocation;
		this.handleChangeInputSpecialRange = handleChangeInputSpecialRange;
		this.handleChangeInputRadioDinamic = handleChangeInputRadioDinamic;

	}

	setDinamicValues(array) {
		const state = this.getState();
		state.values.mensuration.input.values = array;

		this.callback(state);
	}

	getSubcategoriesFromCategoryId(categoryId) {
		const state = this.getState();
		let newCategoryId = categoryId == "comunications" ? "comunication" : categoryId;
		return state.subcategories[`${newCategoryId}Steps`];
	}

	clickAncorAction(href) {
		const targetClick = document.querySelectorAll("a[href='#"+href+"']");
		targetClick[0].click();
	}

	linkMenu(e) {
		const target = e.currentTarget.id;
		if (this.props.auth.isDone(target.slice(1))) return;
		if (name == "disabled") return;
		else {
			const targetClick = document.querySelectorAll("a[href='" + target + "']");
			targetClick[0].click();
		}
	}

	changeCategory(e){
		const id = e.target.hash.slice(1);
		const state = this.getState();
		if(this.props.auth.isDone(id)) {
			this.controller.clickAncorAction(state.categorySelected);
			return;
		}
		const subcategory = this.controller.getSubcategoriesFromCategoryId(id);

		const categories = {
			mensurationQuestions,
			menagementQuestions,
			comunicationQuestions
		};
		const steps = `${id}Questions`;
		
		state[id] = { subcategorySelected: subcategory[0].id};
		state.steps = categories[steps][subcategory[0].id];
		state.categorySelected = id;
		state.subcategoryStep = 0;
		state.loaded = true;

		this.callback(state);
	}

	getThisStep(categorySelected, id) {
		let index = 0;
		
		const subcategories = this.getSubcategoriesFromCategoryId(categorySelected);
		subcategories.map((sub, i) => sub.id == id ? index = i : null);

		return index;
	}

	getForm(categorySelected, subcategorySelected) {
		const selectedForm = `${categorySelected}Questions`;

		const questions = { 
			mensurationQuestions,
			menagementQuestions,
			comunicationQuestions
		};

		return questions[selectedForm];
	}

	changeSubcategory(e){
		const id = e.target.hash.slice(1);
		const state = this.getState();
		const categorySelected = state.categorySelected;

		const subcategories = this.controller.getSubcategoriesFromCategoryId(categorySelected, id);
		
		const index = this.controller.getThisStep(categorySelected, id);

		const subcategory = subcategories[index];
		const subcategorySelected = id;

		const form = this.controller.getForm(categorySelected, subcategorySelected);

		const steps = form[subcategorySelected];
		
		state.values[categorySelected][id] ? null : state.values[categorySelected][id] = {};

		state[categorySelected].subcategorySelected = id;
		state.subcategoryStep = index;
		state.steps = steps;

		this.callback(state);
	}

	async nextSubcategory() {
		const state = this.getState();
		const subcategories = this.controller.getSubcategoriesFromCategoryId(state.categorySelected);
		const nextStep = subcategories[state.subcategoryStep+1];
		
		if(state.subcategoryStep+1 != subcategories.length) {
			const targetClick = document.querySelectorAll("a[href='#"+nextStep.id+"']");
			return targetClick[0].click();
		}
		$("#doneFormAction").modal("open");
		return ;
	}

	async prevSubcategory() {
		const state = this.getState();
		const subcategories = this.controller.getSubcategoriesFromCategoryId(state.categorySelected);
		const nextStep = subcategories[state.subcategoryStep-1];
		if(state.subcategoryStep-1 >= 0) {
			const targetClick = document.querySelectorAll("a[href='#"+nextStep.id+"']");
			return targetClick[0].click();
		}
		return ;
	}

	async setDone(category, auth) {

		let response;

			switch(category) {
				case "mensuration" 	: await this.calculatePointsMensuration(category, auth); break;
				case "menagement" 	: await this.calculatePointsMenagement(category, auth); break;
				case "comunication" : await this.calculatePointsComunication(category, auth); break;
			}
			return true;
	}

	async calculatePointsMensuration(category, auth) {
		const response = await this.context.controller.mensurationsRepo.fetch(this.context.props.auth.userId, {}, {});
		const awsers = response.data;
		
		const waterTreatmentPoints = {
			"1-1-1" 	: 0,
			"1-1-1-2" : 0,
		};
		const measurementSectorizationPoints = {
			"1-2-1-2" : 0,
		};
		const effluentTreatmentPoints = {
			"1-3-1" : 0
		};
		const inputPoints = {
			"1-5-1": 0,
		};
		const othersPoints = {
			"1-6-2-1"	:0,
		};

		// waterTreatmentPoints

		if(awsers.waterTreatment["1"]) {
			let i = 0;
			if(awsers.waterTreatment["1"].jan) i+=1;
			if(awsers.waterTreatment["1"].feb) i+=1;
			if(awsers.waterTreatment["1"].mar) i+=1;
			if(awsers.waterTreatment["1"].apr) i+=1;
			if(awsers.waterTreatment["1"].may) i+=1;
			if(awsers.waterTreatment["1"].jun) i+=1;
			if(awsers.waterTreatment["1"].jul) i+=1;
			if(awsers.waterTreatment["1"].aug) i+=1;
			if(awsers.waterTreatment["1"].sep) i+=1;
			if(awsers.waterTreatment["1"].oct) i+=1;
			if(awsers.waterTreatment["1"].nov) i+=1;
			if(awsers.waterTreatment["1"].dec) i+=1;

			if(i>0 && i<6) 	waterTreatmentPoints["1-1-1"] = 1;
			if(i>5 && i<12) waterTreatmentPoints["1-1-1"] = 2;
			if(i === 12) 		waterTreatmentPoints["1-1-1"] = 3;
		}

		// waterTreatmentPoints

		if(awsers.waterTreatment["2-1"].reusedWater && awsers.waterTreatment["2-1"].rainWater){
			if(awsers.waterTreatment["2-1"].reusedWater <= 10 && awsers.waterTreatment["2-1"].rainWater <= 10)  waterTreatmentPoints["1-1-1-2"] = 2;
			else waterTreatmentPoints["1-1-1-2"] = 3;
		} else {
			waterTreatmentPoints["1-1-1-2"] = 1;
		}

		// measurementSectorizationPoints

		if(awsers.measurementSectorization["1-1"] === "E") measurementSectorizationPoints["1-2-1-2"] = 1;
		if(awsers.measurementSectorization["1-1"] === "M") measurementSectorizationPoints["1-2-1-2"] = 2;
		if(awsers.measurementSectorization["1-1"] === "A") measurementSectorizationPoints["1-2-1-2"] = 3;

		// effluentTreatmentPoints
		
		if(awsers.effluentTreatment["1"]) {
			let i = 0;
			if(awsers.effluentTreatment["1"].jan) i+=1;
			if(awsers.effluentTreatment["1"].feb) i+=1;
			if(awsers.effluentTreatment["1"].mar) i+=1;
			if(awsers.effluentTreatment["1"].apr) i+=1;
			if(awsers.effluentTreatment["1"].may) i+=1;
			if(awsers.effluentTreatment["1"].jun) i+=1;
			if(awsers.effluentTreatment["1"].jul) i+=1;
			if(awsers.effluentTreatment["1"].aug) i+=1;
			if(awsers.effluentTreatment["1"].sep) i+=1;
			if(awsers.effluentTreatment["1"].oct) i+=1;
			if(awsers.effluentTreatment["1"].nov) i+=1;
			if(awsers.effluentTreatment["1"].dec) i+=1;
			
			if(i>0 && i<6) 	effluentTreatmentPoints["1-3-1"] = 1;
			if(i>5 && i<12) effluentTreatmentPoints["1-3-1"] = 2;
			if(i === 12) 		effluentTreatmentPoints["1-3-1"] = 3;
		}

		if(awsers.input.length) {
			let points=0;
			for (var i = awsers.input.length - 1; i >= 0; i--) {
				let n = 0;
				
				if(	awsers.input[i]["1"] && 
						awsers.input[i]["2"]
					) n=1;

				if(	awsers.input[i]["1"] && 
						awsers.input[i]["2"] && 
						awsers.input[i]["3"]
					) n+=2;
				
				if( awsers.input[i]["1"] && 
						awsers.input[i]["2"] && 
						awsers.input[i]["3"] && 
						awsers.input[i]["4"]
					) n+=3;
				
				if(n>points) points = n;
				if(n > 3) points = 3;
			}
			inputPoints["1-5-1"] = points;
		}
			
		let count = 0;
		
		if(awsers.others["2-1"]) 	count = count + 1;
		if(awsers.others["3"]) 		count = count + 1;
		if(awsers.others["4"]) 		count = count + 1;
		if(count == 1) othersPoints["1-6-2-1"] = 1;
		if(count == 2 && awsers.others["2"]) othersPoints["1-6-2-1"] = 2;
		if(
				(count == 3 && 	 awsers.others["2"]) ||
				(count == 2 &&	!awsers.others["2"])
			) othersPoints["1-6-2-1"] = 3;

		const state = this.context.getState();
		
		const mensurationReport = new MensurationReport({
			waterTreatmentPoints,
			measurementSectorizationPoints,
			effluentTreatmentPoints,
			inputPoints, othersPoints 
		});

		state.hiddenReport = false;
		state.reportGraph = mensurationReport;
		state.reportGraphName = "Resultados - Mensuração.";

		await this.context.callback(state);
		mensurationReport.generateChart("reportGraph");
		$("#reportModal").modal("open");
		
		
		auth.done[category] = true;
		auth.waterTreatmentPoints = waterTreatmentPoints;
		auth.measurementSectorizationPoints = measurementSectorizationPoints;
		auth.effluentTreatmentPoints = effluentTreatmentPoints;
		auth.inputPoints = inputPoints;
		auth.othersPoints = othersPoints;
		
		await auth.updateUser();
		this.context.props.setAuthAction(auth);
	}

	async calculatePointsComunication(category, auth) {
		const response = await this.context.controller.comunicationsRepo.fetch(this.context.props.auth.userId, {}, {});
		const awsers = response.data;

		const engagementPoints = {
			"3-1": 0,
			"3-2": 0,
			"3-3": 0,
			"3-4": 0,
		};

		const comunicationPoints = {
			"3-5": 0
		};

		if(awsers.engagement["1"] == "A" ) engagementPoints["3-1"] = 3;
		if(awsers.engagement["1"] == "B" ) engagementPoints["3-1"] = 2;
		if(awsers.engagement["1"] == "C" ) engagementPoints["3-1"] = 1;
		if(awsers.engagement["1"] == "D" ) engagementPoints["3-1"] = 0;
		
		if(awsers.engagement["2"] == "A" ) engagementPoints["3-2"] = 3;
		if(awsers.engagement["2"] == "B" ) engagementPoints["3-2"] = 2;
		if(awsers.engagement["2"] == "C" ) engagementPoints["3-2"] = 1;
		if(awsers.engagement["2"] == "D" ) engagementPoints["3-2"] = 0;

		if(awsers.engagement["3"] == "A" ) engagementPoints["3-3"] = 3;
		if(awsers.engagement["3"] == "B" ) engagementPoints["3-3"] = 2;
		if(awsers.engagement["3"] == "C" ) engagementPoints["3-3"] = 1;
		if(awsers.engagement["3"] == "D" ) engagementPoints["3-3"] = 0;

		if(awsers.engagement["4"] == "A" ) engagementPoints["3-4"] = 3;
		if(awsers.engagement["4"] == "B" ) engagementPoints["3-4"] = 2;
		if(awsers.engagement["4"] == "C" ) engagementPoints["3-4"] = 1;
		if(awsers.engagement["4"] == "D" ) engagementPoints["3-4"] = 0;
		
		if(awsers.comunication["1"] == "A" ) comunicationPoints["3-5"] = 3;
		if(awsers.comunication["1"] == "B" ) comunicationPoints["3-5"] = 2;
		if(awsers.comunication["1"] == "C" ) comunicationPoints["3-5"] = 1;
		if(awsers.comunication["1"] == "D" ) comunicationPoints["3-5"] = 0;
		
		const state = this.context.getState();
		const comunicationReport = new ComunicationReport({ engagementPoints, comunicationPoints });
		state.hiddenReport = false; 
		state.reportGraph = comunicationReport; 
		state.reportGraphName = "Resultados - Engajamento e Comunicação." ;
		
		await this.context.callback(state);
		comunicationReport.generateChart("reportGraph");
		$("#reportModal").modal("open");
		
		auth.done[category] = true;
		auth.engagementPoints = engagementPoints;
		auth.comunicationPoints = comunicationPoints;
		await auth.updateUser();
		this.context.props.setAuthAction(auth);
	}
	
	async calculatePointsMenagement(category, auth) {
		const response = await this.context.controller.menagementsRepo.fetch(this.context.props.auth.userId, {}, {});
		const awsers = response.data;
		
		const governanceResponsibilitiesPoints = {
			"2-1": 0,
			"2-2": 0,
			"2-3": 0,
			"2-4": 0,
		};

		const businessPlanningPoints = {
			"2-5": 0
		};
		
		if(awsers.governanceResponsibilities["1"] == "A" ) governanceResponsibilitiesPoints["2-1"] = 3;
		if(awsers.governanceResponsibilities["1"] == "B" ) governanceResponsibilitiesPoints["2-1"] = 2;
		if(awsers.governanceResponsibilities["1"] == "C" ) governanceResponsibilitiesPoints["2-1"] = 1;
		if(awsers.governanceResponsibilities["1"] == "D" ) governanceResponsibilitiesPoints["2-1"] = 0;

		if(awsers.governanceResponsibilities["2"] == "A" ) governanceResponsibilitiesPoints["2-2"] = 3;
		if(awsers.governanceResponsibilities["2"] == "B" ) governanceResponsibilitiesPoints["2-2"] = 2;
		if(awsers.governanceResponsibilities["2"] == "C" ) governanceResponsibilitiesPoints["2-2"] = 1;
		if(awsers.governanceResponsibilities["2"] == "D" ) governanceResponsibilitiesPoints["2-2"] = 0;

		if(awsers.governanceResponsibilities["3"] == "A" ) governanceResponsibilitiesPoints["2-3"] = 3;
		if(awsers.governanceResponsibilities["3"] == "B" ) governanceResponsibilitiesPoints["2-3"] = 2;
		if(awsers.governanceResponsibilities["3"] == "C" ) governanceResponsibilitiesPoints["2-3"] = 1;
		if(awsers.governanceResponsibilities["3"] == "D" ) governanceResponsibilitiesPoints["2-3"] = 0;

		if(awsers.governanceResponsibilities["4"] == "A" ) governanceResponsibilitiesPoints["2-4"] = 3;
		if(awsers.governanceResponsibilities["4"] == "B" ) governanceResponsibilitiesPoints["2-4"] = 2;
		if(awsers.governanceResponsibilities["4"] == "C" ) governanceResponsibilitiesPoints["2-4"] = 1;
		if(awsers.governanceResponsibilities["4"] == "D" ) governanceResponsibilitiesPoints["2-4"] = 0;

		if(awsers.businessPlanning["1"] == "A" ) businessPlanningPoints["2-5"] = 3;
		if(awsers.businessPlanning["1"] == "B" ) businessPlanningPoints["2-5"] = 2;
		if(awsers.businessPlanning["1"] == "C" ) businessPlanningPoints["2-5"] = 1;
		if(awsers.businessPlanning["1"] == "D" ) businessPlanningPoints["2-5"] = 0;
		

		const state = this.context.getState();
		const menagementReport = new MenagementReport({governanceResponsibilitiesPoints, businessPlanningPoints});
		
		
		state.hiddenReport = false;
		state.reportGraph = menagementReport;
		state.reportGraphName = "Resultados - Gestão.";
		
		await this.context.callback(state);
		
		menagementReport.generateChart("reportGraph");
		$("#reportModal").modal("open");
		
		auth.done[category] = true;
		auth.governanceResponsibilitiesPoints = governanceResponsibilitiesPoints;
		auth.businessPlanningPoints = businessPlanningPoints;
		await auth.updateUser();
		this.context.props.setAuthAction(auth);
	}

	async clickNextStep(category, auth) {
		if (!auth.isDone("mensuration") && category == "mensuration") {

			await this.setDone(category, auth);

			if (!auth.isDone("menagement"))	this.clickAncorAction("menagement");
			else this.clickAncorAction("comunication");

		}else if (!auth.isDone("menagement") && category == "menagement") {

			await this.setDone(category, auth);
			if (!auth.isDone("mensuration")) this.clickAncorAction("mensuration");
			else this.clickAncorAction("comunication");

		}else if (!auth.isDone("comunication")  && category == "comunication") {
			await this.setDone(category, auth);
			if (!auth.isDone("mensuration")) this.clickAncorAction("mensuration");
			if (!auth.isDone("menagement")) this.clickAncorAction("menagement");
			// else this.clickAncorAction("report");
		}
	}

	selectFunctions() {
		const state = this.getState();
		const categorySelected = state.categorySelected;
		const subcategorySelected = state[categorySelected].subcategorySelected;

		return functions["handle_"+categorySelected+"_"+subcategorySelected];
	}

	changeAction(values, id, reference, hasValues) {

		const state = this.getState();
		const step = state[state.categorySelected].subcategorySelected;
		
		if(!state.values[state.categorySelected][step][id]) {
			state.values[state.categorySelected][step][id] = {};
		}
		if(!state.values[state.categorySelected][step][id])
			state.values[state.categorySelected][step][id] = {};

		if(reference && !hasValues)
			state.values[state.categorySelected][step][id][reference] = values[id][reference];
		if (hasValues)
			state.values[state.categorySelected][step]["values"] = values.values;
		else 
			state.values[state.categorySelected][step][id] = values[id];

		this.callback(state);
	}

	async doneAction(toApi, category) {
		let response;
		switch(category) {
			case "mensuration" 	: response = await this.controller.mensurationsRepo.edit(this.props.auth.userId, toApi); break;
			case "menagement" 	: response = await this.controller.menagementsRepo.edit(this.props.auth.userId, toApi); break;
			case "comunication" : response = await this.controller.comunicationsRepo.edit(this.props.auth.userId, toApi); break;
		}
	}

	async init(nextProps) {
		const props = nextProps || this.props;
		const state = this.getState(); 
		const filter = JSON.stringify({
			effluentTreatment: 1, 
			finalProduct: 1, 
			measurementSectorization: 1, 
			waterTreatment: 1,
			_id: 0
		});
		let action;
		let categorySelected = this.state.categorySelected;
		
		if (props.auth.done && props.auth.done.mensuration && props.auth.done.menagement && props.auth.done.comunication){
			this.props.router.push("/report");
			return Materialize.toast("Todos os formularios já foram respondidos", 4000);
		}
		
		if (props.auth.userId){
			if(!props.auth.isDone("mensuration")) {
				categorySelected = "mensuration";
			}			else if (!props.auth.isDone("menagement")) {
				categorySelected = "menagement";
			}			else if (!props.auth.isDone("comunication")) {
				categorySelected = "comunication";
			}
		}
		
		const subcategory = this.controller.getSubcategoriesFromCategoryId(categorySelected);
		
		const values = state.values;
		const categories = { 
			mensurationQuestions,
			menagementQuestions,
			comunicationQuestions,
		};
		const steps = `${categorySelected}Questions`;

		state.values = values;
		state[categorySelected] = { subcategorySelected: subcategory[0].id };
		state.steps = categories[steps][subcategory[0].id];
		state.categorySelected = categorySelected;
		state.subcategoryStep = 0;
		
		await this.callback(state);
	}
}



// WEBPACK FOOTER //
// src/controllers/lib/DashboardController.js